export default "__VITE_ASSET__3BTNY_PV__"